import React from 'react';
import PropTypes from 'prop-types';
import { DataValueMap } from 'Helpers/Testing';
import { Button } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import usePopoverState from 'Hooks/usePopoverState';
import Popover from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Popover';
import {
  MemberLinks,
} from 'Views/Page/Content/Templates/MessagesPage/components/MessagesPageContent/components/MessagesPanel/components/MessagesPanelContent/components/ThreadHeader/components/ThreadParticipantListPopover/components/MemberLinks';
import fr from 'facet-rest';
import {
  FDBox, FDHeadlineText, FDIcon, FDStack,
} from '@facet-wealth/design';

const ThreadMemberNavigationLinksButton = ({ color, memberThreadParticipant }) => {
  const {
    open,
    anchorEl,
    openPopover,
    handleClose,
  } = usePopoverState({});

  return (
    <React.Fragment>
      <FDBox padding={0.5}>
        <Button
          onClick={(event) => openPopover(event)}
          color={color}
          variant={'icon'}
          padding={'normal'}
          {...DataValueMap.init('messages-page-thread-member-navigation-links-button').build()}
        >
          <FDIcon icon={'bolt'} color={'textDisabled'} />
        </Button>
      </FDBox>
      <Popover
        id={'member-navigation-links-popover-menu'}
        open={open}
        rounded
        anchorEl={anchorEl}
        onClose={(event) => {
          event.stopPropagation();
          handleClose();
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <FDStack direction={'column'} spacing={3} flexGrow={1} padding={4}>
          <FDHeadlineText size={'sm'} value={`Quick Navigation ${memberThreadParticipant.attr('householdIdLabel')}`} />
          <MemberLinks
            facetPlanUrl={memberThreadParticipant.relationship(fr.relationships.facetPlan.name)?.link('related')?.url()}
          />
        </FDStack>
      </Popover>
    </React.Fragment>
  );
};

ThreadMemberNavigationLinksButton.defaultProps = {
  color: 'primary',
};

ThreadMemberNavigationLinksButton.propTypes = {
  color: PropTypes.string,
  memberThreadParticipant: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ThreadMemberNavigationLinksButton;
